const loadImage = (src: string) => {
  return new Promise<HTMLImageElement>((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', () => reject(new Error('Failed to load image for cropping.')));
    image.src = src;
  });
};

export const getCroppedImageFile = async (
  imageSrc: string,
  cropAreaPixels: { x: number; y: number; width: number; height: number },
  fileName: string,
  mimeType: string
): Promise<File> => {
  const image = await loadImage(imageSrc);
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  if (!context) {
    throw new Error('Canvas is not available for image cropping.');
  }

  canvas.width = cropAreaPixels.width;
  canvas.height = cropAreaPixels.height;

  context.drawImage(
    image,
    cropAreaPixels.x,
    cropAreaPixels.y,
    cropAreaPixels.width,
    cropAreaPixels.height,
    0,
    0,
    cropAreaPixels.width,
    cropAreaPixels.height
  );

  const normalizedMimeType = mimeType === 'image/gif' ? 'image/png' : mimeType || 'image/png';
  const blob = await new Promise<Blob | null>((resolve) => {
    canvas.toBlob(resolve, normalizedMimeType, 0.92);
  });

  if (!blob) {
    throw new Error('Failed to create cropped image.');
  }

  const safeFileName = /\.[a-z0-9]+$/i.test(fileName)
    ? fileName.replace(/\.[a-z0-9]+$/i, normalizedMimeType === 'image/png' ? '.png' : normalizedMimeType === 'image/webp' ? '.webp' : '.jpg')
    : `${fileName}.${normalizedMimeType === 'image/png' ? 'png' : normalizedMimeType === 'image/webp' ? 'webp' : 'jpg'}`;

  return new File([blob], safeFileName, { type: normalizedMimeType });
};